(() => {
  const dialog = document.getElementById('BzSearchDialog');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const input = dialog.querySelector('input[type="search"]');
  const form = dialog.querySelector('form');
  const idle = dialog.querySelector('.bz-search-idle');
  const results = dialog.querySelector('#BzSearchResults');
  const status = dialog.querySelector('[role="status"]');
  const clear = dialog.querySelector('[type="reset"]');
  const all = dialog.querySelector('.bz-search-all');
  const cache = new Map();
  let timer, controller, sequence = 0, opener, closing = false, scrollY = 0, bodyStyles;
  const query = () => input.value.trim();
  const cancel = () => { clearTimeout(timer); controller?.abort(); sequence++; };
  function close() {
    if (!dialog.open || closing) return;
    closing = true;
    cancel();
    dialog.classList.add('bz-search-closing');
    const finish = () => {
      dialog.close(); dialog.classList.remove('bz-search-closing'); closing = false;
      document.documentElement.classList.remove('bz-search-locked');
      Object.assign(document.body.style, bodyStyles);
      window.scrollTo({top:scrollY,behavior:'instant'});
      document.querySelectorAll('[data-bz-search-open]').forEach(e => e.setAttribute('aria-expanded','false'));
      opener?.focus({preventScroll:true});
    };
    setTimeout(finish, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200);
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-bz-search-open]');
    if (!trigger || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (dialog.open) return;
    opener = trigger;
    scrollY = window.scrollY;
    bodyStyles = {position:document.body.style.position,top:document.body.style.top,width:document.body.style.width};
    Object.assign(document.body.style,{position:'fixed',top:`-${scrollY}px`,width:'100%'});
    document.documentElement.classList.add('bz-search-locked');
    dialog.showModal();
    trigger.setAttribute('aria-expanded','true');
    if (matchMedia('(min-width:750px)').matches) input.focus({preventScroll:true});
    else { input.blur(); dialog.querySelector('[data-bz-search-close]').focus({preventScroll:true}); }
    if(query()) update();
  });
  dialog.querySelector('[data-bz-search-close]').addEventListener('click',close);
  dialog.addEventListener('click',e => {if(e.target === dialog) close();});
  dialog.addEventListener('cancel',e => {e.preventDefault();close();});
  form.addEventListener('submit',e => {if(!query()) {e.preventDefault();input.focus();}});
  form.addEventListener('reset',e => {e.preventDefault();input.value='';update();input.focus();});
  function render(html, term) {
    results.innerHTML = html;
    results.hidden = false;
    status.textContent = '';
    status.classList.add('visually-hidden');
    status.textContent = results.querySelector('[data-result-count]')?.textContent || '';
    results.removeAttribute('aria-busy');
  }
  async function search(term, id) {
    if(cache.has(term)) {render(cache.get(term),term);return;}
    const requestController = new AbortController();
    controller = requestController;
    const timeout = setTimeout(()=>requestController.abort(),8000);
    try {
      const url = new URL(dialog.dataset.endpoint, location.origin);
      url.search = new URLSearchParams({q:term,'resources[type]':'product,collection,page,query','resources[limit]':'8','resources[limit_scope]':'each','resources[options][unavailable_products]':'last',section_id:'bezelor-predictive-search'});
      const response = await fetch(url,{signal:requestController.signal,credentials:'same-origin'});
      if(!response.ok) throw new Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const content = doc.querySelector('[data-bz-search-response]');
      if(!content) throw new Error('Missing results');
      if(id !== sequence || query() !== term || !dialog.open) return;
      cache.set(term,content.innerHTML);
      if(cache.size>20) cache.delete(cache.keys().next().value);
      render(content.innerHTML,term);
    } catch(error) {
      if(id !== sequence || !dialog.open) return;
      status.classList.remove('visually-hidden');status.textContent=dialog.dataset.error;
      results.hidden=true;
    } finally {clearTimeout(timeout);if(id === sequence)results.removeAttribute('aria-busy');}
  }
  function update() {
    cancel();
    const term=query();clear.hidden=!term;idle.hidden=!!term;all.hidden=!term;results.hidden=true;results.innerHTML='';
    status.classList.remove('visually-hidden');status.textContent='';
    if(!term) return;
    const url=new URL(form.action);url.search=new URLSearchParams({q:term,'options[prefix]':'last'});all.href=url.toString();
    results.setAttribute('aria-busy','true');status.textContent=dialog.dataset.loading;
    const id=sequence;timer=setTimeout(()=>search(term,id),220);
  }
  input.addEventListener('input',e=>{if(!e.isComposing)update();});
  input.addEventListener('compositionend',update);
  function selectTab(tab) {
    results.querySelectorAll('[role="tab"]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});
  }
  results.addEventListener('click',e=>{const tab=e.target.closest('[role="tab"]');if(tab)selectTab(tab);});
  dialog.addEventListener('keydown',e=>{
    const tab=e.target.closest('[role="tab"]');
    if(tab && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {
      e.preventDefault();const tabs=[...results.querySelectorAll('[role="tab"]')];let i=tabs.indexOf(tab);
      i=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
      selectTab(tabs[i]);tabs[i].focus();return;
    }
    if(['ArrowDown','ArrowUp'].includes(e.key) && !tab) {
      const links=[...results.querySelectorAll('a')].filter(a=>a.getClientRects().length);
      if(!links.length)return;const i=links.indexOf(document.activeElement);
      if(document.activeElement===input || i>=0){e.preventDefault();const next=e.key==='ArrowDown'?i+1:i-1;if(next<0)input.focus();else links[Math.min(next,links.length-1)].focus();}
    }
  });
})();
